/**
 * Dashboard TypeScript types
 */

export interface User {
  id: string;
  email: string;
  name: string;
  avatarUrl?: string;
  createdAt: string;
  lastLogin: string;
}

export interface APIKey {
  id: string;
  name?: string;
  keyPreview: string;
  tier: 'FREE' | 'PRO';
  requestsUsed: number;
  requestsLimit: number;
  createdAt: string;
  lastUsedAt?: string;
  isActive: boolean;
}

export interface DashboardStats {
  totalKeys: number;
  activeKeys: number;
  totalRequests: number;
  requestsThisMonth: number;
}

export interface AnalyticsData {
  requestsOverTime: {
    date: string;
    requests: number;
  }[];
  endpointUsage: {
    endpoint: string;
    count: number;
  }[];
  recentActivity: {
    endpoint: string;
    timestamp: string;
    status: 'success' | 'error';
  }[];
}

export interface SessionResponse {
  user: User | null;
}

// Enhanced analytics types
export interface PerformanceMetrics {
  avgResponseTime: number;
  p50ResponseTime: number;
  p95ResponseTime: number;
  p99ResponseTime: number;
  responseTimeOverTime: {
    date: string;
    avgTime: number;
  }[];
}

export interface TokenSavings {
  totalJsonTokens: number;
  totalToonTokens: number;
  totalSavings: number;
  savingsPercent: number;
  conversionsCount: number;
}

export interface ErrorMetrics {
  totalErrors: number;
  errorRate: number;
  errorsByEndpoint: {
    endpoint: string;
    errors: number;
  }[];
  errorTrend: {
    date: string;
    errors: number;
  }[];
}

export interface ConversionHistory {
  id: string;
  timestamp: string;
  inputType: 'json' | 'toon';
  outputTypes: string[];
  inputSize: number;
  tokensSaved: number;
  endpoint: string;
}

export interface UsagePattern {
  peakHours: number[];
  mostUsedDay: string;
  avgRequestsPerDay: number;
  conversionTypePreference: {
    type: string;
    percentage: number;
  }[];
}

export interface HeatmapData {
  date: string;
  count: number;
  level: 0 | 1 | 2 | 3 | 4;
}

// Admin panel types
export interface AdminUser {
  id: string;
  email: string;
  name: string;
  avatarUrl?: string;
  createdAt: string;
  lastLogin: string;
  apiKeysCount: number;
  totalRequests: number;
}

export interface PlatformStats {
  totalUsers: number;
  totalApiKeys: number;
  totalRequests: number;
  requestsThisMonth: number;
  totalMockEndpoints: number;
  activeUsers7Days: number;
}

// Admin email constant
export const ADMIN_EMAIL = 'krishcdbry@gmail.com';
